import { createContext, useContext, useMemo } from 'react';

export type TeamCreateStep = 'build' | 'captain' | 'vice';

export interface TeamPageModeContextValue {
  isCreateMode: boolean;
  isTeamConfirmed: boolean;
}

const defaultValue: TeamPageModeContextValue = {
  isCreateMode: false,
  isTeamConfirmed: false,
};

const TeamPageModeContext = createContext<TeamPageModeContextValue>(defaultValue);

export interface TeamPageModeProviderProps extends TeamPageModeContextValue {
  children: React.ReactNode;
}

export const TeamPageModeProvider = ({
  children,
  isCreateMode,
  isTeamConfirmed,
}: TeamPageModeProviderProps) => {
  const value = useMemo(() => {
    return {
      isCreateMode,
      isTeamConfirmed,
    };
  }, [isCreateMode, isTeamConfirmed]);

  return <TeamPageModeContext.Provider value={value}>{children}</TeamPageModeContext.Provider>;
};

export const useTeamPageMode = () => {
  return useContext(TeamPageModeContext);
};
